  <img class="warning-neutral-icon confirm-content-icon" *ngIf="data.type === 'neutral'" src="/assets/img/channels/warning-neutral.svg" alt="warning-neutral">
  <img class="warning-strong-icon  confirm-content-icon" *ngIf="data.type === 'strong'" src="/assets/img/channels/warning-strong.svg" alt="warning-strong">
  <h3 class="confirm-content-verify-title" mat-dialog-title translate>{{data.title}}</h3>
<mat-dialog-content class="mat-typography">
  <p class="confirm-content-verify-description" translate>{{data.description}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div class="confirm-buttons-wrapper">
    <button class="channels-button"
            id="cancel"
            (click)="close()"
            translate>CANCEL
    </button>
    <button class="channels-button confirm"
            *ngIf="data.type === 'neutral'"
            [mat-dialog-close]="data.type"
            translate>CONFIRM
    </button>
    <button class="channels-button delete"
            id="delete"
            *ngIf="data.type === 'strong'"
            [mat-dialog-close]="data.type"
            translate>DELETE
    </button>
  </div>
</mat-dialog-actions>
